import { Deferred } from './Deferred';

// NATIVE splash screen (BK logo)
// why? there is a bug on iOS if you display a modal before splash screen is gone you can't get off of the splash screen
// expose splash screen status to Modals across the app to avoid
export const nativeSplashScreenHiddenDeferred = new Deferred();

/* animated (not native) splash screen - (lottie animation, takeover video etc.) */
export const animatedSplashScreenHiddenDeferred = new Deferred();
